<template>
  <form
    class="api-keys-create-form"
    @submit.prevent="submitForm"
  >
    <h3>
      Opret ny API nøgle
    </h3>
    <Box>
      <BaseInput
        label="Udstedes til"
        v-model="form.company"
        :disabled="loading"
      />
      <BaseFormField label="Aktiv">
        <BaseSelect
          label="name"
          :placeholder="form.status | IsActive"
          @select="updateSatus"
          :options="[{value: true, name: 'Aktiv'}, {value: false, name: 'Inaktiv'}]"
          :disabled="loading"
        />
      </BaseFormField>
      <BaseFormField label="Udvidet adgang">
        <BaseSelect
          label="name"
          :placeholder="form.extended | IsExtended"
          @select="updateExtended"
          :options="[{value: true, name: 'Ja'}, {value: false, name: 'Nej'}]"
          :disabled="loading"
        />
      </BaseFormField>

      <div class="api-keys-create-form__inline">
        <BaseButton
          label="Opret nøgle"
          :disabled="loading || $v.$invalid"
        />
        <div>
          <BaseSpinner
            height="40px"
            width="40px"
            v-if="loading"
          />
        </div>
      </div>
    </Box>
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import BaseSpinner from '../../BaseSpinner.vue';
import BaseSelect from '../../BaseSelect.vue';
import BaseFormField from '../../BaseFormField.vue';
import BaseButton from '../../BaseButton.vue';
import Box from '../../Box.vue';
import BaseInput from '../../BaseInput.vue';
import IsExtended from '../../../filters/IsExtended';
import IsActive from '../../../filters/IsActive';
import APIKeysService from '../../../services/APIKeysService';

export default {
    name: 'CreateAPIKeysForm',
    components: {
        BaseInput, Box, BaseButton, BaseFormField, BaseSelect, BaseSpinner,
    },
    filters: { IsExtended, IsActive },
    data() {
        return {
            loading: false,
            form: {
                company: '',
                extended: false,
                status: false,
            },
        };
    },
    validations: {
        form: {
            company: { required },
        },
    },
    methods: {
        updateExtended(e) {
            this.form.extended = e.value;
        },
        updateSatus(e) {
            this.form.status = e.value;
        },
        async submitForm() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$snotify.error('Ikke alle felter er udfyldt korrekt.');
                return;
            }

            try {
                this.loading = true;
                const payload = await APIKeysService.create(this.form);

                this.$snotify.success(`${payload.company} er oprettet`);
                this.loading = false;
                this.$emit('created', payload);

                this.form.company = '';
                this.form.extended = false;
            } catch (error) {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.api-keys-create-form {
    max-width: 500px;
    margin-top: 50px;

    &__inline {
        display: flex;

        svg {
            margin-left: 10px;
        }
    }
}
</style>
